import React from 'react'
import type { IMAGE_DETAIL_TAB } from './infoView'

export interface SampleDetailContext {
    tabValue: IMAGE_DETAIL_TAB,
    onTabChange: (val:IMAGE_DETAIL_TAB)=>void,
    currentImage: any,
    onInit: any,
    initWaterfall: ()=>void,
    onChange: any,
    setBanOperation: any,
    onVisibleChange: any,
    boxIndex: any,
    setBoxIndex: any,
    onDeleteItem: any,
    //
    commentTotal: any,
    onInitCommentTotal: any,
    // 批注
    notes: any,
    setNotes: any,
    onInitNotes: any,
    isMove: any,
    setIsMove: any,
    activeNoteIndex: any,
    setActiveNoteIndex: any,
    isAnnotate: any,
    setIsAnnotate: any,
    showRight: any,
    setShowRight: any,
    isPage: any,
}

export const ImageDetailContext = React.createContext({})
